import { z } from "zod";

import { i18n } from "@lingui/core";
import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

/**
 * A message read at validation time rather than at module load, and readable
 * before a locale is set: zod runs its checks wherever it is imported, and the
 * catalogue is not always up by then.
 */
export const text = (descriptor: MessageDescriptor): string =>
  i18n.locale ? i18n._(descriptor) : (descriptor.message ?? descriptor.id);

/** The shape a zod check takes an error factory in. */
export const fails = (descriptor: MessageDescriptor) => ({
  error: () => text(descriptor),
});

const DATE = /^\d{4}-\d{2}-\d{2}$/;

const TIME = /^\d{2}:\d{2}$/;

const AMOUNT = /^\d+(?:[.,]\d{1,2})?$/;

export const date: z.ZodNullable<z.ZodString> = z
  .string()
  .regex(DATE, fails(msg`Enter a date`))
  .nullable();

export const time: z.ZodNullable<z.ZodString> = z
  .string()
  .regex(TIME, fails(msg`Enter a time as HH:MM`))
  .nullable();

/** Spaces group the thousands and a comma stands in for the point. */
export const amount: z.ZodNullable<z.ZodString> = z
  .string()
  .refine(
    (value) => AMOUNT.test(value.replace(/\s/gu, "")),
    fails(msg`Enter an amount`),
  )
  .nullable();

export const reference: z.ZodNullable<z.ZodNumber> = z
  .number()
  .int()
  .positive()
  .nullable();
